export class AuditorInfo {
         auditorId: number;
         userId: string;
         schoolId: number;
         fullName: string;
         fullNameEn: string;
         userNumber: string;
         isAssigned?: boolean;
       }